module.exports = __webpack_public_path__ + "static/img/ent-40.2c03017.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/productspic/entpic/ent-40.jpg
// module id = OoQX
// module chunks = 52